const mutations = {
  getTransactionLogID: (state, detail_transaction) => {
    state.detail_transaction = detail_transaction;
  },
};

export default mutations;
